  <template>
  <div class="correct">
    <div class="per-button top-btn" @click="handleChange">
      {{ $t('lang.external.personal.content.two.返回') }}
    </div>
    <div class="content">
      <span>{{ $t('lang.external.personal.content.two.实验名称') }}</span>
      <span>{{ reportInfo.courseName }}</span>
    </div>
    <div class="content">
      <span
        >{{ $t('lang.external.personal.content.two.姓名：')
        }}{{ reportInfo.stuName }}</span
      >
      <span
        >{{ $t('lang.external.personal.content.two.学号：')
        }}{{ reportInfo.stuNum }}</span
      >
    </div>
    <div class="content">
      <span>{{ $t('lang.external.personal.content.two.实验目的：') }}</span>
      <div v-if="data.status === 1">
        <p>{{ reportInfo.purpose }}</p>
      </div>
      <div v-else>
        <el-input
          type="textarea"
          :rows="5"
          :placeholder="$t('lang.external.personal.content.two.请输入内容')"
          v-model="purpose"
        >
        </el-input>
      </div>
    </div>
    <div class="content">
      <span>{{ $t('lang.external.personal.content.two.实验过程：') }}</span>
      <div v-if="data.status === 1">
        <p>{{ reportInfo.content }}</p>
      </div>
      <div v-else>
        <el-input
          type="textarea"
          :rows="5"
          :placeholder="$t('lang.external.personal.content.two.请输入内容')"
          v-model="content"
        >
        </el-input>
      </div>
    </div>
    <div class="content">
      <span>{{ $t('lang.external.personal.content.two.心得体会') }}</span>
      <div v-if="data.status === 1">
        <p>{{ reportInfo.experience }}</p>
      </div>

      <div v-else>
        <el-input
          type="textarea"
          :rows="5"
          :placeholder="$t('lang.external.personal.content.two.请输入内容')"
          v-model="experience"
        >
        </el-input>
      </div>
    </div>
    <div class="content subimt" v-if="!data.status">
      <div class="per-button btn-active" @click="submit">
        {{ $t('lang.external.personal.content.two.提交') }}
      </div>
    </div>
    <div class="content" v-if="data">
      <span>{{ $t('lang.external.personal.content.two.教师评价：') }}</span>
      <div>
        <p>{{ reportInfo.opinion }}</p>
      </div>
      <div class="evaluate">
        <span>{{ $t('lang.external.personal.content.two.教师评分：') }}</span>
        <div class="evaluate-score">{{ reportInfo.score }}</div>
      </div>
    </div>
  </div>
</template>

  <script>
import { reportDetail, reportEdit } from '@/api/personalCenter/index'
import { formatLan } from '@/utils/lanFormat'
export default {
  name: 'correct',
  components: {},
  props: ['data'],
  data() {
    return {
      reportInfo: {},
      purpose: '',
      content: '',
      experience: '',
    }
  },
  watch: {},
  computed: {},
  created() {
    this.loadReportData()
  },
  mounted() {},
  methods: {
    handleChange() {
      this.$emit('change', true)
      this.$store.commit('SET_CRUMBS', undefined)
    },
    loadReportData() {
      reportDetail(this.data.id).then((res) => {
        console.log(res)
        const { data } = res
        data.courseName = formatLan(data.courseName)
        this.reportInfo = data
        this.purpose = data.purpose
        this.content = data.content
        this.experience = data.experience
      })
    },
    submit() {
      var commitData = {
        id: this.data.id,
        purpose: this.purpose,
        content: this.content,
        experience: this.experience,
      }
      reportEdit(commitData).then((res) => {
        this.$notify({
          type: 'success',
          message: res.msg,
          duration: 1500,
          title: 'SUCCESS',
        })
        this.loadReportData()
      })
    },
  },
}
</script>

  <style lang="scss" scoped>
.correct {
  position: relative;
  width: 100%;
  font-size: 14px;
  color: #666666;
  .top-btn {
    position: absolute;
    top: -80px;
    right: 0;
  }
  .content {
    padding: 20px 50px;
    border-bottom: 1px solid #eaeaea;
    ::v-deep .el-textarea {
      margin: 20px 0;
      .el-textarea__inner {
        font-size: 14px;
        color: #696969;
        background-color: #edf2f6;
        border: 0;
      }
    }
    p {
      padding-left: 2rem;
    }
    &:first-child {
      color: #7a7a7a;
    }
    &:nth-child(3) {
      span {
        &:first-child {
          margin-right: 20%;
        }
      }
    }
    &:last-child {
      border-bottom: 0;
    }
    .evaluate {
      display: flex;
      align-items: center;
      &-score {
        min-width: 90px;
        text-align: center;
        line-height: 1.7;
        color: var(--red-color);
        background-color: #edf2f6;
        border-radius: 4px;
      }
    }
  }
  .subimt {
    display: flex;
    align-items: center;
  }
}
</style>